module.exports = __webpack_public_path__ + "static/appInto07-9016b47313fbf0abdbf3dda7f6d21d5d.png";